import { useState } from "react";
import { FilterList } from "@mui/icons-material";
import localize from "../../common/localize";
import ModalBackground from "./ModalBackground";
import ModalFilter from "./ModalFilter";
import FilterBox from "./FilterBox";

export default function FilterManager({
  filterDataValue,
  setFilterDataValue,
  defaultFilteringValue,
  filterOptionsValue,
  filterItemNameValue,
  lateral_padding,
}) {
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState(null);

  const addFilter = (newFilters) => {
    const filters = Array.isArray(newFilters) ? newFilters : [newFilters];
    let current = [...(filterDataValue ?? [])];
    filters.forEach((f) => {
      const idx = current.findIndex((x) => x.Name === f.Name);
      if (idx >= 0) {
        current[idx] = f;
      } else {
        current.push(f);
      }
    });
    setFilterDataValue(current);
    setSelectedFilter(null);
  };

  const applyFilters = (filters) => {
    if (Array.isArray(filters)) {
      let current = [...(filterDataValue ?? [])];
      filters.forEach((f) => {
        const idx = current.findIndex((x) => x.Name === f.Name);
        if (idx >= 0) {
          current[idx] = f;
        } else {
          current.push(f);
        }
      });
      setFilterDataValue(current);
    } else if (filters) {
      addFilter(filters);
    }
    setSelectedFilter(null);
    setShowFilterModal(false);
  };

  const applyFilter = () => {
    if (selectedFilter) {
      addFilter(selectedFilter);
    }
    setShowFilterModal(false);
  };

  return (
    <div
      className={`flex items-center gap-2 mt-1 flex-wrap ${
        lateral_padding ? "lateral_padding" : ""
      }`}
    >
      {showFilterModal && (
        <ModalBackground
          isDrawerMode
          showModal={showFilterModal}
          setShowModal={setShowFilterModal}
          title={localize.filter_list}
          okButtonText={localize.accept}
          onClickToCancel={() => setShowFilterModal(false)}
          onClickToSubmit={() => {
            applyFilter();
          }}
          Component={
            <ModalFilter
              filterOptions={filterOptionsValue}
              currentFilters={filterDataValue}
              selectedFilter={selectedFilter}
              setSelectedFilter={setSelectedFilter}
              onSubmit={applyFilters}
            />
          }
        />
      )}

      <div>
        <button
          className="btn app_button app_general_button_data btn-sm"
          onClick={() => {
            setSelectedFilter(null);
            setShowFilterModal(true);
          }}
        >
          <span className="mr-2">{localize.filter_list}</span>
          <FilterList className="text-lg" />
        </button>
      </div>

      <div style={{ flex: 1 }}>
        <FilterBox
          filterItemName={filterItemNameValue}
          filterData={filterDataValue}
          setFilterData={setFilterDataValue}
          defaultFiltering={defaultFilteringValue ?? []}
          // saveFilter={
          //   filterItemNameValue?.includes('newness_filter') ||
          //   filterItemNameValue?.includes('preorder_filter')
          // }
          saveFilter
        />
      </div>
    </div>
  );
}
